import React, { createContext, useContext, useState, useEffect } from 'react';

const LoginContext = createContext();

const LoginProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

const isSignIn = async () => {
    console.log(global?.token, "token context");
    if (global?.token && global.token != "") {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
}

useEffect(()=>{
  isSignIn()
},[global?.token])

  return (
    <LoginContext.Provider
      value={{ isLoggedIn, setIsLoggedIn }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => useContext(LoginContext);

export default LoginProvider;

